import React, { useEffect, useState, useContext, useCallback } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { RiCoupon2Fill } from 'react-icons/ri';

import { ApiHelper } from '../../../../../helpers/apihelper';
import AppConfigContext from '../../../../app_layout/app_config_context';
import {  useLocation } from 'react-router-dom';
import * as Constants from '../../../../../helpers/constants'

const RecurringCoupon = ({userData}) => {

  const [recur, setRecur] = useState(null)
  const location = useLocation()
  const user_id = new URLSearchParams(location.search).get('user_id')

  const appConfig = useContext(AppConfigContext)
  const client = appConfig.client

  const getRecurrUserInfo = useCallback(() => {

    if (!user_id || !client) return

    const requestBody = {
      co_user_id: user_id,
      co_org_id: user_id,
      client_secret: Constants.CLIENT_SECRET
    }

    const body = _.pick(
      requestBody,
      ApiHelper(client, 'ORG_INFO').API_BODY
    )

    ApiHelper(client, 'ORG_INFO')
      .API(client, body)
      .then(function (response) {

        if (
          response &&
          response.status === Constants.CO_API.SUCCESS &&
          response.data &&
          response.data.recur &&
          response.data.recur.name
        ) {
          setRecur(response.data.recur)
        }
        else {
          setRecur(null)
        }

      })
      .catch(function () {
        setRecur(null)
      })

  }, [user_id, client])

  useEffect(function () {
    if (userData?.user_type === 'organization') {
      getRecurrUserInfo()
    }
  }, [getRecurrUserInfo, userData?.user_type])

  if (!recur || userData?.user_role !== 'owner') {
    return null
  }

  const formatCredits = function (credits) {
    return Number(credits).toLocaleString()
  }

  const formatDate = function (date) {
    return moment(date).utc().format('DD MMM YYYY hh:mm A')
  }

  return (

    <div className='recurring-coupon-card'>

      <div className='recurring-coupon-header'>

        <div className='recurring-coupon-icon'>
          <RiCoupon2Fill
            size={18}
          />
        </div>
        <div className='recurring-coupon-text'>

          <div className='recurring-coupon-title'>
            Recurring Coupon
          </div>
          <div className='recurring-coupon-subtitle'>
            You currently have the following coupon.
          </div>

        </div>

      </div>
      <div className='recurring-coupon-name'>
        {recur.name} {formatCredits(recur.credits)}/{recur.type}
      </div>
      <div className='recurring-coupon-date'>
        Next credit allocation will be on{' '}
        {formatDate(recur.recur_credit_reset_date)} (UTC)
      </div>

    </div>

  )
}

export default RecurringCoupon